import React, { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { currentUserService } from '../services/currentUserService';
import type { UserWithRolesDto } from '../api-client/models/UserWithRolesDto';

const UserProfile: React.FC = () => {
  const [user, setUser] = useState<UserWithRolesDto | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadUser = async () => {
      setIsLoading(true);
      try {
        const userData = await currentUserService.getCurrentUser();
        if (isMounted) {
          setUser(userData);
        }
      } catch (error) {
        console.error('Failed to load current user', error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadUser();

    const unsubscribe = currentUserService.onUserLoad((userData) => {
      if (isMounted) {
        setUser(userData);
        setIsLoading(false);
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  if (isLoading) {
    return <Nav.Link>Загрузка...</Nav.Link>;
  }

  if (!user) {
    return <Nav.Link>Пользователь</Nav.Link>;
  }

  return (
    <Link to="/profile" className="nav-link">
      {user.username}
    </Link>
  );
};

export default UserProfile;
